module.exports = __webpack_public_path__ + "media/images/front/pc/institution-treatment-information/img_hospital-7ce6b206422effbcf8de72a9dd0f8003.jpg";